import React from "react";
import { default as Card_Clockin } from "components/Dashboard/Cards/Card_Clockin";
import { default as Card_TotalWorkingHours } from "components/Dashboard/Cards/Card_TotalWorkingHours";
import { default as Card_PendingRequests } from "components/Dashboard/Cards/Card_PendingRequests";
import { default as Card_NextAbsences } from "components/Dashboard/Cards/Card_NextAbsences";
import { default as Card_WeekTimeRegistrations } from "components/Dashboard/Cards/Card_WeekTimeRegistrations";
import { default as Card_Birthdays } from "components/Dashboard/Cards/Card_Birthdays";
import { default as Card_WeekShifts } from "components/Dashboard/Cards/Card_WeekShifts";
import { default as Card_NextHolidays } from "components/Dashboard/Cards/Card_NextHolidays";
import { default as Card_OpenTimeRegistrations } from "components/Dashboard/Cards/Card_OpenTimeRegistrations";
import { default as Card_WorkingToday } from "components/Dashboard/Cards/Card_WorkingToday";
import { default as Card_Notifications } from "components/Dashboard/Cards/Card_Notifications";
import { default as Card_WorkingHoursPeriod } from "components/Dashboard/Cards/Card_WorkingHoursPeriod";

export const WIDGET_NAMES = {
	DAY_TIME_REGISTRATIONS: "widgets.names.DAY_TIME_REGISTRATIONS",
	TOTAL_WORKING_HOURS: "widgets.names.TOTAL_WORKING_HOURS",
	WORKING_HOURS_WEEK: "widgets.names.WORKING_HOURS_WEEK",
	WORKING_HOURS_MONTH: "widgets.names.WORKING_HOURS_MONTH",
	WORKING_HOURS_YEAR: "widgets.names.WORKING_HOURS_YEAR",
	PENDING_REQUESTS: "widgets.names.PENDING_REQUESTS",
	NEXT_ABSENCES: "widgets.names.NEXT_ABSENCES",
	WEEK_TIME_REGISTRATION: "widgets.names.WEEK_TIME_REGISTRATION",
	BIRTHDAYS: "widgets.names.BIRTHDAYS",
	WEEK_SHIFTS: "widgets.names.WEEK_SHIFTS",
	NEXT_HOLIDAYS: "widgets.names.NEXT_HOLIDAYS",
	OPEN_TIME_REGISTRATIONS: "widgets.names.OPEN_TIME_REGISTRATIONS",
	WHO_IS_WORKING_TODAY: "widgets.names.WHO_IS_WORKING_TODAY",
	NOTIFICATIONS: "widgets.names.NOTIFICATIONS",
};

export const WIDGETS = {
	DAY_TIME_REGISTRATIONS: Card_Clockin,
	TOTAL_WORKING_HOURS: Card_TotalWorkingHours,
	WORKING_HOURS_WEEK: Card_WorkingHoursPeriod,
	WORKING_HOURS_MONTH: Card_WorkingHoursPeriod,
	WORKING_HOURS_YEAR: Card_WorkingHoursPeriod,
	PENDING_REQUESTS: Card_PendingRequests,
	NEXT_ABSENCES: Card_NextAbsences,
	WEEK_TIME_REGISTRATION: Card_WeekTimeRegistrations,
	BIRTHDAYS: Card_Birthdays,
	WEEK_SHIFTS: Card_WeekShifts,
	NEXT_HOLIDAYS: Card_NextHolidays,
	OPEN_TIME_REGISTRATIONS: Card_OpenTimeRegistrations,
	WHO_IS_WORKING_TODAY: Card_WorkingToday,
	NOTIFICATIONS: Card_Notifications,
};

export function getWidgetComponent(jsonObj, hasSuperPowers) {
	if (jsonObj && jsonObj.name && WIDGETS[jsonObj.name]) {
		const WidgetComponent = WIDGETS[jsonObj.name];
		const widgetClass = `widget_${jsonObj.width}x${jsonObj.height}`;

		// TODO apaño provisional con permisos pero debería guardarse en DB
		if (
			!hasSuperPowers &&
			(jsonObj.name == "OPEN_TIME_REGISTRATIONS" ||
				jsonObj.name == "WHO_IS_WORKING_TODAY")
		)
			return null;

		return (
			<div className={widgetClass} key={jsonObj.id}>
				<WidgetComponent {...jsonObj} />
			</div>
		);
	}
	return null;
}

// export function sortByPosition(a, b) {
// 	if (!a.position) a.position = 99999;
// 	if (!b.position) b.position = 99999;

// 	if (a.position < b.position) {
// 		return -1;
// 	}
// 	if (a.position > b.position) {
// 		return 1;
// 	}
// 	return 0;
// }
export function sortByPosition(a, b) {
	const ap = a.position ?? 99999;
	const bp = b.position ?? 99999;
	return ap - bp;
}
